var exports = {
  "n": "link__T9LMYq",
};

module.exports = exports;
